module.exports = __webpack_public_path__ + "static/media/tab-wavy-chocolatey.ae87d850.png";